
<template>
  <!-- 中间页面,防止当前组件中的方法在子页面中执行 -->
  <index-page v-if="$route.name === 'Product'" />
  <router-view v-else :key="$route.path + Math.random()" />
</template>

<script>
import indexPage from "./indexPage";
export default {
  components: {
    indexPage,
  },
};
</script>
